import APIService from '@/services/api-service'
const resource = '/tariff'

class TariffService extends APIService {
  public constructor () {
    super()
    this.mountAuthorizationToken()
  }

  public getTariffDetails (type: any) {
    return this.connector.get(`${resource}/${type}/details`)
  }

  public deleteTriff (tariffId: any) {
    return this.connector.delete(`${resource}/${tariffId}/delete`)
  }

  public save (data: any) {
    return this.connector.post(`${resource}/save`, data)
  }
}

export default new TariffService()
